import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { DEFAULT_ROUTE } from '../common/constants';
import { routes } from './Router';

const isUnknownRoute = (_routeNames: string[], pathname: string): boolean =>
    !routes.some(route => pathname.startsWith(route));

export const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isUnknownRoute(routes, pathname)) {
            navigate(DEFAULT_ROUTE);
        }
    }, [pathname]);

    return null;
};
